import { render, staticRenderFns } from "./MinimalFooter.vue?vue&type=template&id=7c3a650d&scoped=true&"
import script from "./MinimalFooter.vue?vue&type=script&lang=js&"
export * from "./MinimalFooter.vue?vue&type=script&lang=js&"
import style0 from "./MinimalFooter.vue?vue&type=style&index=0&id=7c3a650d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3a650d",
  null
  
)

export default component.exports